import styles from '@/components/Common/Nav/Link/Link.styles';
import { NavLinkProps } from 'react-router-dom';
// INTERFACES

export interface LinkProps extends NavLinkProps {
  to: string;
  icon?: React.ReactNode;
  label?: string;
  collapse?: boolean;
  horizontal?: boolean;
}

// FUNCTIONS

export const GET_LABEL_STYLES = (icon: React.ReactNode) => {
  return { ...styles.label, ...(icon ? styles.label.withIcon : {}) };
};

export const GET_LINK_STYLES = (horizontal: boolean) => {
  return {
    ...styles.link,
    ...(horizontal ? styles.link.horizontal : {}),
  };
};
